/**
 * <OpenShiftDialog> — open a new shift with an opening float.
 */
import { useState } from "react";
import { toast } from "sonner";
import { OperationalDrawer, BottomActionBar } from "@/components/operational";
import { PlayCircle } from "lucide-react";
import { foApi , formatApiError } from "../foApi";
import { NumberInput } from "@/components/ui/number-input";

export default function OpenShiftDialog({ open, onOpenChange, hotelId, onSuccess }) {
  const [opening, setOpening] = useState("");
  const [station, setStation] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    const minor = Math.round(parseFloat(opening) * 100);
    if (Number.isNaN(minor) || minor < 0) { toast.error("Enter a valid opening float"); return; }
    setSaving(true);
    try {
      await foApi.openShift({
        hotel_id: hotelId,
        opening_float_minor: minor,
        station_code: station || null,
      });
      setOpening(""); setStation("");
      onSuccess?.();
    } catch (e) {
      toast.error(formatApiError(e, "Failed to open shift"));
    } finally { setSaving(false); }
  };

  return (
    <OperationalDrawer open={open} onOpenChange={onOpenChange}
      title="Open Shift" subtitle="Record your opening cash float"
      size="sm" testid="open-shift-drawer"
      footer={
        <BottomActionBar
          primary={{ label: saving ? "Opening..." : "Open Shift",
                       icon: PlayCircle, tone: "primary", onClick: submit,
                       loading: saving, disabled: opening === "",
                       testid: "open-shift-confirm" }}
          secondaryActions={[
            { label: "Cancel", tone: "secondary", onClick: () => onOpenChange(false), testid: "open-shift-cancel" }
          ]}
        />
      }>
      <div className="p-4 space-y-4">
        <div>
          <label className="text-[12px] uppercase tracking-wider text-slate-500 font-semibold">Opening float (₹)</label>
          <NumberInput min={0} step="0.01" value={opening}
                   onChange={e => setOpening(e.target.value)}
                   className="w-full mt-1 border-2 border-slate-300 rounded-lg p-3 text-[18px] font-semibold h-14"
                   placeholder="0.00"
                   data-testid="open-shift-float"/>
        </div>
        <div>
          <label className="text-[12px] uppercase tracking-wider text-slate-500 font-semibold">Station / Counter (optional)</label>
          <input type="text" value={station} onChange={e => setStation(e.target.value)}
                   className="w-full mt-1 border-2 border-slate-300 rounded-lg p-3 text-[14px] h-12"
                   placeholder="e.g. Front Desk 1"
                   data-testid="open-shift-station"/>
        </div>
      </div>
    </OperationalDrawer>
  );
}
